module.exports = __webpack_public_path__ + "static/media/mg-teal.ba3cdfa5.png";